export const focus = {
  inserted(el: HTMLElement) {
    el.focus();
  },
};
